import React, { useContext,useState } from "react";
import AppContext from "../../context/Context";
import ButtonIcon from "../common/ButtonIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Form, Row } from "reactstrap";
import SikkaInput from "../common/SikkaInput";
import { useForm } from "react-hook-form";
import apiCall from "../../services/apiCall";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";

const DeleteTeamMemember = ({
  openPopup,
  setOpenPopup,
  setIsRefresh,
  selectedTeamMember,
}) => {
  const { loginUserDetails } = useContext(AppContext);
  const {
    register,
    handleSubmit,
    errors,
    watch,
    setError,
    clearError,
  } = useForm();
  const [modalLoader, setModalLoader] = useState(false);
  const [showModalContent, setShowModalContent] = useState(true); // Modal Content
  const [message, setMessage] = useState("");

  const DeleteTeamMember = (values) => {
    setModalLoader(true);
    setIsRefresh(false);
    let body = {
      devid: selectedTeamMember.devid,
      deleted_by: loginUserDetails.user_name,
      comment: values.comment,
    };

    apiCall
      .servertrip(
        "DELETE",
        "delete_team_member",
        loginUserDetails,
        undefined,
        body
      )
      .then(
        (res) => {
          setModalLoader(false);
          setShowModalContent(false);
          setMessage("TeamMember successfully removed!");
          toast.success("TeamMember successfully removed");
          setIsRefresh(true);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
          setModalLoader(false);
          setShowModalContent(true);
        }
      );
    setIsRefresh(false);
  };
  return (
    <>
      <Form onSubmit={handleSubmit(DeleteTeamMember)}>
        {modalLoader ? (
          <>
            <Spinner animation="border" />
          </>
        ) : (
          <>
            {showModalContent ? (
              <>
                <Row>
                  <Col>
                    <SikkaInput
                      label="Updated By"
                      value={loginUserDetails.user_name}
                      name="updatedBy"
                      id="updatedBy"
                      disabled
                      innerRef={register({
                        required: "Updated By is required",
                      })}
                      errors={errors}
                    />
                    <SikkaInput
                      label="Comment"
                      name="comment"
                      id=""
                      innerRef={register({
                        required: "Comment is required",
                        pattern: {
                          value: /^[^\s]+(\s+[^\s]+)*$/,
                          message: "Invalid comment",
                        },
                      })}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row
                  className="modal-footer px-md-3 bg-light"
                  style={{
                    marginLeft: "-16px",
                    marginRight: "-16px",
                    marginBottom: "-16px",
                  }}
                >
                  <ButtonIcon
                    color="outline-secondary"
                    size="sm"
                    icon="Sync"
                    className="ml-1 mt-lg-0 mb-2"
                    iconClassName="fs--2"
                    onClick={() => {
                      setOpenPopup(false);
                    }}
                  >
                    Cancel
                  </ButtonIcon>
                  <ButtonIcon
                    color="danger"
                    size="sm"
                    icon="trash"
                    className="ml-1 mt-lg-0 mb-2"
                    iconClassName="fs--2"
                    type="submit"
                  >
                    Delete
                  </ButtonIcon>
                </Row>
              </>
            ) : (
              <label>{message}</label>
            )}
          </>
        )}
      </Form>
    </>
  );
};

export default DeleteTeamMemember;
